import { IconButton } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Button = IconButton.withConfig({
  width: '$12',
  height: '$12',
  borderRadius: 'full',
  backgroundColor: primitive.$white,
  alignItems: 'center',
  justifyContent: 'center',
});
